import { connectToStores } from 'fluxible-addons-react';
import DocumentStore from '../../../stores/DocumentStore';
import NavigationStore from '../../../stores/NavigationStore';
import { ApiExplorer } from './ApiExplorer';
export default connectToStores(ApiExplorer, [DocumentStore, NavigationStore], function (context, props) {
    var url = props.currentRoute.url;
    var doc = context.getStore(DocumentStore).getDocument(url);
    return { doc: doc };
});
